"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosRegisterSessionSchema = exports.APosRegisterSessionStatusSchema = exports.APosSalesSummarySchema = exports.APosCashDropSchema = exports.APosDenominationSchema = exports.APosRegisterSchema = exports.APosPaymentConfigSchema = exports.APosHardwareConfigSchema = exports.APosCustomerDisplayConfigSchema = exports.APosVarianceDirectionSchema = exports.APosCashDropReasonSchema = exports.APosGatewayIdSchema = exports.APosTipConfigSchema = exports.APOS_CREDIT_TYPES = exports.APosRegisterPaymentMethodSchema = exports.APosBarcodeScannerModeSchema = exports.APosEmvModeSchema = exports.APosRegisterStatusSchema = exports.APosTerminalTypeSchema = exports.APosScreenModeSchema = void 0;
exports.calculateDenominationTotal = calculateDenominationTotal;
const zod_1 = require("zod");
const registerCardSetup_1 = require("../../../registerCardSetup");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
// Enums
exports.APosScreenModeSchema = zod_1.z.enum(['SINGLE', 'DUAL_WEB', 'DUAL_ANDROID']);
exports.APosTerminalTypeSchema = zod_1.z.enum(['pos', 'kiosk', 'customer_display', 'android_dual_screen', 'online_sales']);
exports.APosRegisterStatusSchema = zod_1.z.enum(['inactive', 'active', 'in_session', 'maintenance']);
// 'spin_cloud' is a Dejavoo terminal reached through SPIn's cloud. Distinct
// from 'cloud', which is NMI Cloud — one value for two gateways would route a
// Dejavoo sale through NMI.
exports.APosEmvModeSchema = zod_1.z.enum(['cloud', 'sdk', 'usb', 'spin_cloud', 'rtpay', 'external', 'none', 'sunbay']);
exports.APosBarcodeScannerModeSchema = zod_1.z.enum(['keyboard_wedge', 'camera', 'sdk']);
/*
  `credit_dejavoo` KEEPS MEANING SPIn USB. It is written on registers already in
  production, so its meaning is fixed; SPIn Cloud is a NEW method beside it.

  Two methods rather than one with a route flag, for the same reason NMI has
  `credit_nmi_cloud` and `credit_nmi_direct`: the POS takes a card down two
  genuinely different code paths — a native USB plugin, or an HTTP call to our
  backend — and a tender that hides which one is in use cannot be reasoned about
  from a register, a receipt or a report.
*/
exports.APosRegisterPaymentMethodSchema = zod_1.z.enum([
    'cash', 'external_card', 'ebt',
    'split', 'credit_external', 'credit_nmi_cloud', 'credit_nmi_direct',
    'credit_dejavoo', 'credit_dejavoo_cloud', 'credit_dejavoo_rtpay',
    // MagTek DynaFlex II via UniGate (pos-magtek-service) — only on a card-setup register.
    'credit_magtek',
    // SUNBAY Tapro on a SUNMI CPad Pay (pos-sunbay-service) — only on a card-setup register.
    'credit_sunbay',
]);
// Credit-type mutex: only one of these credit methods may be active per register at a time
exports.APOS_CREDIT_TYPES = [
    'credit_external', 'credit_nmi_cloud', 'credit_nmi_direct',
    'credit_dejavoo', 'credit_dejavoo_cloud', 'credit_dejavoo_rtpay',
    'credit_magtek', 'credit_sunbay',
];
exports.APosTipConfigSchema = zod_1.z.object({
    enabled: zod_1.z.boolean().default(false),
    percentages: zod_1.z.array(zod_1.z.number().min(0).max(100)).default([15, 18, 20, 25]),
    allowCustom: zod_1.z.boolean().default(true),
    allowSkip: zod_1.z.boolean().default(true),
});
exports.APosGatewayIdSchema = zod_1.z.enum(['nmi', 'stripe', 'square']).nullable();
exports.APosCashDropReasonSchema = zod_1.z.enum([
    'safe_drop',
    'bank_deposit',
    'manager_request',
    'threshold_exceeded',
    'cash_tip',
    'other',
]);
exports.APosVarianceDirectionSchema = zod_1.z.enum(['short', 'even', 'over']);
// Customer Display Config
exports.APosCustomerDisplayConfigSchema = zod_1.z.object({
    theme: zod_1.z.enum(['light', 'dark']).default('dark'),
    /** When not false, the customer display follows the till's POS theme. Pinned themes set false. */
    followCashierTheme: zod_1.z.boolean().optional(),
    accentColor: zod_1.z.string().optional(),
    effect: zod_1.z.enum(['none', 'snow', 'confetti', 'hearts', 'fireworks', 'leaves', 'halloween', 'shamrocks']).default('none').optional(),
    idle: zod_1.z.object({
        logoUrl: zod_1.z.string().nullable().optional(),
        storeName: zod_1.z.string().optional(),
        tagline: zod_1.z.string().optional(),
        mode: zod_1.z.enum(['static', 'playlist']).default('static'),
        playlistId: zod_1.z.string().nullable().optional(),
        logoFit: zod_1.z.enum(['contain', 'cover']).default('contain').optional(),
    }),
    promo: zod_1.z.object({
        enabled: zod_1.z.boolean().default(false),
        text: zod_1.z.string().optional(),
        imageUrl: zod_1.z.string().nullable().optional(),
        placement: zod_1.z.enum(['idle', 'both']).default('both'),
    }).optional(),
    qr: zod_1.z.object({
        enabled: zod_1.z.boolean().default(false),
        target: zod_1.z.enum(['loyalty', 'storefront', 'menu', 'custom']).default('loyalty'),
        customUrl: zod_1.z.string().optional(),
        position: zod_1.z.enum(['top-left', 'top-center', 'top-right', 'bottom-left', 'bottom-center', 'bottom-right']).default('top-right').optional(),
    }).optional(),
    thankYou: zod_1.z.object({
        message: zod_1.z.string().optional(),
        showLogo: zod_1.z.boolean().default(true),
        // What to show above the thank-you message: one of the built-in animations,
        // the business logo, or a custom uploaded picture.
        visual: zod_1.z.enum(['animation', 'logo', 'image']).default('animation').optional(),
        // Vector marks (2026-09-20) first; the emoji keys after them are RETIRED
        // from the picker but still valid here — a terminal saved with one must
        // keep validating. AGENTIC_POS maps each to its nearest vector mark.
        animation: zod_1.z.enum(['check', 'ripple', 'burst', 'sparkle', 'heart', 'clap', 'gift', 'smiley', 'pray', 'thumbsup', 'highfive']).default('check').optional(),
        imageUrl: zod_1.z.string().nullable().optional(),
    }).optional(),
});
// Hardware Config
exports.APosHardwareConfigSchema = zod_1.z.object({
    emvDeviceId: zod_1.z.string().nullable().default(null),
    emvMode: exports.APosEmvModeSchema.default('none'),
    printerId: zod_1.z.string().nullable().default(null),
    cashDrawerId: zod_1.z.string().nullable().default(null),
    barcodeScanner: exports.APosBarcodeScannerModeSchema.default('keyboard_wedge'),
    scaleId: zod_1.z.string().nullable().default(null),
    /** SUNMI T3 only — primary + backup card reader (registerCardSetup.ts). Absent on every other register. */
    cardSetup: registerCardSetup_1.RegisterCardSetupSchema.optional(),
    /** Written by the server alongside `cardSetup`: how the till reaches each device. */
    cardSetupResolved: registerCardSetup_1.RegisterCardSetupResolvedSchema.optional(),
});
// Payment Config
exports.APosPaymentConfigSchema = zod_1.z.object({
    gatewayId: exports.APosGatewayIdSchema.default(null),
    merchantId: zod_1.z.string().nullable().default(null),
    allowedMethods: zod_1.z.array(exports.APosRegisterPaymentMethodSchema).default(['cash']),
    // SA-assigned vs tenant-enabled subset. `assigned` is set by super-admin,
    // `enabled` is the tenant-togglable subset.
    assigned: zod_1.z.array(exports.APosRegisterPaymentMethodSchema).default([]),
    enabled: zod_1.z.array(exports.APosRegisterPaymentMethodSchema).default([]),
    overrideActive: zod_1.z.boolean().default(false),
    tipConfig: exports.APosTipConfigSchema.optional(),
    surchargeApply: zod_1.z.boolean().default(false),
    splitPayment: zod_1.z.boolean().default(false),
    // Customer-display signature per payment type id (APosRegisterPaymentMethodSchema
    // values). Missing key = false. Readers ignore 'split' only
    // (SIGNATURE_EXEMPT_METHODS). Stored at register.paymentTypes.signatureRequired.
    // Plus the non-method key `debit` (SIGNATURE_DEBIT_KEY): the signature asked
    // after a card payment the customer ran as DEBIT; the card tender's own key
    // (e.g. `credit_dejavoo`) means the CREDIT rail.
    signatureRequired: zod_1.z.record(zod_1.z.string(), zod_1.z.boolean()).default({}),
    /*
      Does this register ask the customer CREDIT or DEBIT before a card sale?
      Stored at register.paymentTypes.debitEnabled.
  
      The invariant is `surchargeApply ⇒ debitEnabled`: a surcharge is lawful on
      credit and not on debit, and readers report brand and last4 but never the
      product type, so a surcharging register must ask. "Surcharge on, debit off"
      is a compliance failure rather than a setting, and payment-types-put
      refuses to store it.
  
      The reverse does NOT hold — a register may ask with no surcharge at all
      (both totals come out equal and the customer picks a rail), and a reader
      with no debit support is simply one with this off.
  
      OPTIONAL, WITH NO DEFAULT, ON PURPOSE. "Never set" has to stay
      distinguishable from "set to false": rows written before this field derive
      their answer from `surchargeApply`, so every register that surcharges today
      keeps prompting exactly as it does now. A `.default(false)` here would
      collapse that distinction on the first parse and silently stop those tills
      asking.
    */
    debitEnabled: zod_1.z.boolean().optional(),
});
// Register
exports.APosRegisterSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    registerId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(100),
    screenMode: exports.APosScreenModeSchema.default('SINGLE'),
    status: exports.APosRegisterStatusSchema.default('inactive'),
    hardwareConfig: exports.APosHardwareConfigSchema,
    paymentConfig: exports.APosPaymentConfigSchema,
    currentSessionId: zod_1.z.string().nullable().default(null),
    terminalType: exports.APosTerminalTypeSchema.optional(),
    customerDisplayConfig: exports.APosCustomerDisplayConfigSchema.optional(),
    /** Per-register cashier (register-side) theme. Defaults to dark when unset. */
    theme: zod_1.z.enum(['light', 'dark']).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
// Denomination
exports.APosDenominationSchema = zod_1.z.object({
    bills: zod_1.z.object({
        '1': zod_1.z.number().int().min(0).default(0),
        '5': zod_1.z.number().int().min(0).default(0),
        '10': zod_1.z.number().int().min(0).default(0),
        '20': zod_1.z.number().int().min(0).default(0),
        '50': zod_1.z.number().int().min(0).default(0),
        '100': zod_1.z.number().int().min(0).default(0),
    }),
    coins: zod_1.z.object({
        '0.01': zod_1.z.number().int().min(0).default(0),
        '0.05': zod_1.z.number().int().min(0).default(0),
        '0.10': zod_1.z.number().int().min(0).default(0),
        '0.25': zod_1.z.number().int().min(0).default(0),
        '0.50': zod_1.z.number().int().min(0).default(0),
        '1.00': zod_1.z.number().int().min(0).default(0),
    }),
});
// Utility function
function calculateDenominationTotal(denom) {
    const billTotal = Object.entries(denom.bills).reduce((sum, [value, qty]) => sum + parseFloat(value) * qty, 0);
    const coinTotal = Object.entries(denom.coins).reduce((sum, [value, qty]) => sum + parseFloat(value) * qty, 0);
    return Math.round((billTotal + coinTotal) * 100) / 100;
}
// Cash Drop
exports.APosCashDropSchema = zod_1.z.object({
    dropId: id_schema_1.EntityIdSchema,
    amount: zod_1.z.number().positive(),
    reason: exports.APosCashDropReasonSchema,
    reasonNote: zod_1.z.string().max(500).optional(),
    employeeId: id_schema_1.EntityIdSchema,
    employeeName: zod_1.z.string(),
    managerId: id_schema_1.EntityIdSchema.nullable().default(null),
    managerName: zod_1.z.string().nullable().default(null),
    timestamp: zod_1.z.number(),
    businessDate: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
});
// Sales Summary (populated on session close)
exports.APosSalesSummarySchema = zod_1.z.object({
    totalTransactions: zod_1.z.number().int().min(0).default(0),
    totalSales: zod_1.z.number().min(0).default(0),
    totalRefunds: zod_1.z.number().min(0).default(0),
    totalVoids: zod_1.z.number().min(0).default(0),
    netSales: zod_1.z.number().default(0),
    averageSale: zod_1.z.number().min(0).default(0),
    salesByMethod: zod_1.z.object({
        cash: zod_1.z.object({ count: zod_1.z.number().int().default(0), amount: zod_1.z.number().default(0) }),
        credit_nmi_cloud: zod_1.z.object({ count: zod_1.z.number().int().default(0), amount: zod_1.z.number().default(0) }),
        external_card: zod_1.z.object({ count: zod_1.z.number().int().default(0), amount: zod_1.z.number().default(0) }),
        ebt: zod_1.z.object({ count: zod_1.z.number().int().default(0), amount: zod_1.z.number().default(0) }),
    }),
    voidCount: zod_1.z.number().int().min(0).default(0),
    refundCount: zod_1.z.number().int().min(0).default(0),
});
// Register Session
exports.APosRegisterSessionStatusSchema = zod_1.z.enum(['open', 'closed']);
exports.APosRegisterSessionSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    sessionId: id_schema_1.EntityIdSchema,
    registerId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    employeeId: id_schema_1.EntityIdSchema,
    status: exports.APosRegisterSessionStatusSchema.default('open'),
    openedAt: zod_1.z.number(),
    closedAt: zod_1.z.number().nullable().default(null),
    startingCash: zod_1.z.number().min(0),
    startingDenomination: exports.APosDenominationSchema,
    endingCash: zod_1.z.number().min(0).nullable().default(null),
    endingDenomination: exports.APosDenominationSchema.nullable().default(null),
    expectedCash: zod_1.z.number().nullable().default(null),
    variance: zod_1.z.number().nullable().default(null),
    varianceDirection: exports.APosVarianceDirectionSchema.nullable().default(null),
    varianceNote: zod_1.z.string().max(500).nullable().default(null),
    cashDrops: zod_1.z.array(exports.APosCashDropSchema).default([]),
    salesSummary: exports.APosSalesSummarySchema.nullable().default(null),
    ttl: zod_1.z.number().optional(),
});
// T3 card setup (2026-10-14) — re-exported so `pos-register.schema` is where a reader finds it.
__exportStar(require("../../../registerCardSetup"), exports);
//# sourceMappingURL=pos-register.schema.js.map